import React, { useState } from 'react';

interface IGlobalContextProps {
	countRequest: number;
	setCountRequest: (countRequest: number) => void;
	updateRequestTable: boolean;
	setUpdateRequestTable: (updateRequestTable: boolean) => void;
}

export const GlobalContext = React.createContext<IGlobalContextProps>({
	countRequest: 0,
	setCountRequest: () => {
		/* tslint:disable:no-empty */
	},
	updateRequestTable: false,
	setUpdateRequestTable: () => {
		/* tslint:disable:no-empty */
	},
});

export const GlobalContextProvider = (props: any) => {
	const [countRequest, setCountRequest] = useState(0);
	const [updateRequestTable, setUpdateRequestTable] = useState(false);

	return (
		<GlobalContext.Provider
			value={{
				countRequest,
				setCountRequest,
				updateRequestTable,
				setUpdateRequestTable,
			}}
		>
			{props.children}
		</GlobalContext.Provider>
	);
};
